import axios from 'axios';
import { t } from 'i18next';
import Swal from 'sweetalert2';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const getAttributes = async () => {
    const res = await axios.post(`${API_URL}common/attributes`);
    return res;
};
export const getColumnToExportAudience = async () => {
    const res = await axios.post(`${API_URL}common/getColumnToExportAudience`);
    return res;
};
export const exportAudience = async (values) => {
    try {
        const res = await axios.post(`${API_URL}audience-management/export`, {
            audienceIds: values.audienceIds,
            exportedTypeIds: values.exportedTypeIds,
            selectedDataIds: values.selectedDataIds,
        });

        const link = document.createElement('a');
        link.href = res?.data?.data?.link;
        link.click();
        return;
    } catch (err) {
        Swal.fire({
            title: t('Notification'),
            text: err.response?.data?.showMessage ?? 'Xuất tập khách hàng thất bại',
            icon: 'warning',
            confirmButtonText: t('Yes'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
            },
        });
    }

    // try {
    //     const response = await axios.post(`${API_URL}audience-management/export`, {
    //         audienceIds: values.audienceIds,
    //         exportedTypeIds: values.exportedTypeIds,
    //         selectedDataIds: values.selectedDataIds,
    //     }, {
    //         responseType: 'blob', // important
    //     });
    //     // create file link in browser's memory
    //     const href = URL.createObjectURL(response.data);

    //     // create "a" HTML element with href to file & click
    //     const link = document.createElement('a');
    //     link.href = href;
    //     link.setAttribute('download', 'audience.xlsx'); //or any other extension
    //     document.body.appendChild(link);
    //     link.click();

    //     // clean up "a" element & remove ObjectURL
    //     document.body.removeChild(link);
    //     URL.revokeObjectURL(href);
    // } catch (error) {
    //     Swal.fire({
    //         title: t('Notification'),
    //         text: error.response?.data?.showMessage ?? 'Xuất tập khách hàng thất bại',
    //         icon: 'warning',
    //         confirmButtonText: t('Yes'),
    //         customClass: {
    //             confirmButton: 'btn btn-danger font-weight-bolder',
    //         },
    //     });
    //     console.error('Error exporting audience:', error);
    // }
};

export const delete_audience = async (id) => {
    const userId = localStorage.getItem('userId');

    const res = await axios.post(`${API_URL}audience-management/delete-audience`, {
        audienceId: id,
        userId,
    });
    return res;
};

// Xóa toàn bộ khách hàng ra khỏi tập (tập vẫn tồn tại). API trả về ngay,
// việc dọn dữ liệu chạy ngầm nên tập bị khóa (edit/convert/clear đều 400) tới khi xong.
export const clear_audience_customers = async (id) => {
    const userId = localStorage.getItem('userId');

    const res = await axios.post(`${API_URL}audience-management/clear-audience-customers`, {
        audienceId: id,
        userId,
    });
    return res;
};
